import Settings from '../wrappers/Settings';
import { I18n, Store } from '../wrappers';
const PrintServiceElectron = {
    async init() { },
    async detectPrinters() {
        const terminal = Store.get('terminal');
        const detectedPrinters = await Settings.electron.invoke('psDetectPrinters');
        const networkPrinter = {
            terminal: terminal,
            printer: { name: 'network_printer', description: I18n.t('printers.network') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 48,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        const defaultEscposPrinterOptions = {
            id: undefined,
            escpos: true,
            width: 100,
            height: undefined,
            margin: undefined,
            scaleFactor: undefined,
            charsPerLine: 48,
            dpi: 203,
            ipAddress: undefined,
            qrCodeSize: 200,
            version: 1,
            other: {}
        };
        const defaultPrinterOptions = {
            id: undefined,
            escpos: false,
            width: 50,
            height: 297,
            margin: 0,
            scaleFactor: 100,
            charsPerLine: 48,
            dpi: 203,
            ipAddress: undefined,
            qrCodeSize: undefined,
            version: 1,
            other: {}
        };
        const printers = detectedPrinters.map(p => {
            const defaultOptions = p.options.escpos ? defaultEscposPrinterOptions : defaultPrinterOptions;
            return {
                terminal: terminal,
                printer: p.printer,
                options: { ...defaultOptions, ...p.options }
            };
        });
        return [...printers, networkPrinter];
    },
    async sendToPrinter(printer, data) {
        return Settings.electron.invoke('psPrint', printer, data);
    },
    async openDrawer(printer) {
        return Settings.electron.invoke('psOpenDrawer', printer);
    },
    /**
     * Whether the installed desktop shell prints the receipt logo line. A shell from before the
     * logo has no `psCapabilities` handler: the call rejects, which counts as no.
     */
    async canPrintLogo() {
        try {
            const capabilities = await Settings.electron.invoke('psCapabilities');
            return capabilities?.logo === true;
        }
        catch {
            return false;
        }
    },
};
export default PrintServiceElectron;
//# sourceMappingURL=PrintServiceElectron.js.map